import { ADMIN_URL } from '../../Admin/constants/constants';

const routes = [
  {
    name: 'Employees',
    link: `/${ADMIN_URL}/employees/`,
    isDefault: true,
  },
];

export { routes };
